import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
export default {
    methods: {
        getEmployee() {
            var Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: 151

            };
            $http.get("api/Department/GetDepartmentListById", Params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.TreeDataList = Data;
                })
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/components/chooseDept/services.js